import NiceModal from "@ebay/nice-modal-react";
import FlexChild from "layouts/flex/FlexChild";
import ModalBase from "modals/base/ModalBase";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import style from "./CustomerStatusModal.module.css";
import { style as buttonStyle } from "components/buttons/AdminCustomButton";
import { adminRequester } from "App";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { Container } from "@mui/material";
import { CButton, CSpinner } from "@coreui/react";
import AdminCustomButton from "components/buttons/AdminCustomButton";
import P from "components/P";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import InputText from "components/inputs/InputText";
import AdminInputImage from "components/inputs/image/AdminInputImage";

const CustomerEditModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  const { data, onSuccess } = props;
  const inputs = useRef([]);
  const [withHeader, withFooter] = [true, false];
  const [width, height] = ["min(95%, 1200px)", "80vh"];
  const withCloseButton = true;
  const clickOutsideToClose = true;
  const modal = useRef();
  const title = "상품 정보";
  const buttonText = t("close");
  const [isMounted, setMounted] = useState(false);
  const [isSpin, setSpin] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, [isMounted]);
  useEffect(() => {
    if (isMounted) {
    }
  }, [isMounted]);
  const onSaveClick = () => {
    setSpin(true);
    let customer = {};
    inputs.current[13].isValid().then(() => {
      inputs.current[14].isValid().then(() => {
        customer.first_name = inputs.current[1].getValue();
        customer.phone = inputs.current[2].getValue();
        customer.businessMutual = inputs.current[3].getValue();
        customer.businessNumber = inputs.current[4].getValue();
        customer.businessAddress = `[${inputs.current[5].getValue()}] ${inputs.current[6].getValue()}${inputs.current[7].getValue()}`;
        customer.businessName = inputs.current[8].getValue();
        customer.businessPhone = inputs.current[9].getValue();
        customer.businessEmail = inputs.current[10].getValue();
        customer.businessDetail = inputs.current[11].getValue();
        customer.businessType = inputs.current[12].getValue();
        customer.businessCertificate = inputs.current[13].getValue();
        customer.businessRetail = inputs.current[14].getValue();
        adminRequester.updateCustomer(data.id, customer, () => {
          onSuccess?.();
          modal.current.close();
        });
      });
    });
  };
  const onCloseClick = () => {
    modal.current.close();
  };
  const openPasswordChange = () => {
    NiceModal.show("passwordChange", {
      id: data?.id,
    });
  };
  const resetPassword = () => {
    NiceModal.show("confirm", {
      message: "정말 초기화하시겠습니까?",
      confirmText: "네",
      cancelText: "아니요",
      onConfirm: () => {
        adminRequester.updateCustomer(data.id, {
          resetPassword: true,
          password_hash:
            "c2NyeXB0AAEAAAABAAAAAeQDR7wSR4/kee1YISYuTUlVM6CX5QMlevNYu262wdYdEyyhvjjQKFkgBcuAoGeRL4IgRelmV2tvFpfMSFUnYd9GZel8LfK7+IQZwPdp7aby",
        });
      },
    });
  };
  return (
    <ModalBase
      borderRadius={"10px"}
      headerStyle
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
    >
      <div style={{ overflow: "scroll", height: "75vh" }}>
        <Container maxWidth={1500}>
          <VerticalFlex gap={20}>
            <HorizontalFlex>
              <FlexChild width="max-content">
                <P weight="bold" size={20}>
                  개인정보
                </P>
              </FlexChild>
            </HorizontalFlex>
            <FlexChild>
              <div className={style.container} sty>
                <VerticalFlex>
                  <FlexChild>
                    <div className={style.contentWrap}>
                      <VerticalFlex gap={20}>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>이메일(아이디)</P>
                            </FlexChild>
                            <FlexChild>
                              <VerticalFlex alignItems="flex-start" gap={10}>
                                <FlexChild>
                                  <InputText
                                    validable={false}
                                    ref={(el) => (inputs.current[0] = el)}
                                    value={data?.email}
                                    readOnly
                                    feedback="이메일이 이미 등록되어있습니다."
                                  />
                                </FlexChild>
                              </VerticalFlex>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>비밀번호</P>
                            </FlexChild>
                            <FlexChild>
                              <VerticalFlex alignItems="flex-start" gap={10}>
                                <FlexChild width="max-content">
                                  <AdminCustomButton
                                    style={buttonStyle.white_border}
                                    text="비밀번호 변경"
                                    onClick={openPasswordChange}
                                  />
                                  {/* <AdminCustomButton
                                    style={buttonStyle.white_border}
                                    text="비밀번호 초기화"
                                    onClick={resetPassword}
                                  /> */}
                                </FlexChild>
                              </VerticalFlex>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>이름</P>
                            </FlexChild>
                            <FlexChild>
                              <VerticalFlex alignItems="flex-start" gap={10}>
                                <FlexChild>
                                  <InputText
                                    validable={false}
                                    ref={(el) => (inputs.current[1] = el)}
                                    value={data?.first_name}
                                  />
                                </FlexChild>
                              </VerticalFlex>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>휴대폰번호</P>
                            </FlexChild>
                            <FlexChild>
                              <VerticalFlex alignItems="flex-start" gap={10}>
                                <FlexChild>
                                  <InputText
                                    validable={false}
                                    ref={(el) => (inputs.current[2] = el)}
                                    value={data?.phone}
                                  />
                                </FlexChild>
                              </VerticalFlex>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                      </VerticalFlex>
                    </div>
                  </FlexChild>
                </VerticalFlex>
              </div>
            </FlexChild>
            <HorizontalFlex>
              <FlexChild width="max-content">
                <P weight="bold" size={20}>
                  사업자정보
                </P>
              </FlexChild>
            </HorizontalFlex>
            <FlexChild>
              <div className={style.container} sty>
                <VerticalFlex>
                  <FlexChild>
                    <div className={style.contentWrap}>
                      <VerticalFlex gap={20}>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>상호</P>
                            </FlexChild>
                            <FlexChild>
                              <VerticalFlex alignItems="flex-start" gap={10}>
                                <FlexChild>
                                  <InputText
                                    validable={false}
                                    ref={(el) => (inputs.current[3] = el)}
                                    value={data?.businessMutual}
                                  />
                                </FlexChild>
                              </VerticalFlex>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>사업자 번호</P>
                            </FlexChild>
                            <FlexChild>
                              <VerticalFlex alignItems="flex-start" gap={10}>
                                <FlexChild>
                                  <InputText
                                    validable={false}
                                    ref={(el) => (inputs.current[4] = el)}
                                    value={data?.businessNumber}
                                  />
                                </FlexChild>
                              </VerticalFlex>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>주소</P>
                            </FlexChild>
                            <FlexChild>
                              <VerticalFlex alignItems="flex-start" gap={10}>
                                <FlexChild>
                                  <HorizontalFlex
                                    gap={10}
                                    justifyContent="flex-start"
                                  >
                                    <FlexChild width="max-content">
                                      <InputText
                                        validable={false}
                                        ref={(el) => (inputs.current[5] = el)}
                                        value={
                                          data?.businessAddress &&
                                          data?.businessAddress
                                            ?.split("] ")[0]
                                            .replace("[", "")
                                        }
                                        readOnly
                                        style={{ width: 380 }}
                                      />
                                    </FlexChild>
                                    <FlexChild width="max-content">
                                      <AdminCustomButton
                                        text="우편번호 찾기"
                                        style={buttonStyle.blue}
                                        onClick={() => {
                                          NiceModal.show("addressKr", {
                                            onCallback: (data) => {
                                              inputs.current[5].setValue(
                                                data.zonecode
                                              );
                                              inputs.current[6].setValue(
                                                data.address
                                              );
                                              inputs.current[7].empty();
                                            },
                                          });
                                        }}
                                      />
                                    </FlexChild>
                                  </HorizontalFlex>
                                </FlexChild>
                                <FlexChild>
                                  <HorizontalFlex
                                    gap={10}
                                    justifyContent="flex-start"
                                  >
                                    <FlexChild width="max-content">
                                      <InputText
                                        validable={false}
                                        ref={(el) => (inputs.current[6] = el)}
                                        value={`${data?.businessAddress &&
                                          data?.businessAddress
                                            ?.split("] ")?.[1]
                                            ?.split(")")[0]})`}
                                        readOnly
                                        style={{ width: 400 }}
                                      />
                                    </FlexChild>
                                    <FlexChild width="max-content">
                                      <InputText
                                        validable={false}
                                        ref={(el) => (inputs.current[7] = el)}
                                        value={
                                          data?.businessAddress &&
                                          data?.businessAddress
                                            ?.split("] ")?.[1]
                                            ?.split(")")?.[1]
                                        }
                                        style={{ width: 380 }}
                                      />
                                    </FlexChild>
                                  </HorizontalFlex>
                                </FlexChild>
                              </VerticalFlex>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>대표자 이름</P>
                            </FlexChild>
                            <FlexChild>
                              <VerticalFlex alignItems="flex-start" gap={10}>
                                <InputText
                                  validable={false}
                                  ref={(el) => (inputs.current[8] = el)}
                                  value={data?.businessName}
                                />
                              </VerticalFlex>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>대표 전화번호</P>
                            </FlexChild>
                            <FlexChild>
                              <VerticalFlex alignItems="flex-start" gap={10}>
                                <InputText
                                  validable={false}
                                  ref={(el) => (inputs.current[9] = el)}
                                  value={data?.businessPhone}
                                />
                              </VerticalFlex>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>대표 이메일</P>
                            </FlexChild>
                            <FlexChild>
                              <VerticalFlex alignItems="flex-start" gap={10}>
                                <InputText
                                  validable={false}
                                  ref={(el) => (inputs.current[10] = el)}
                                  value={data?.businessEmail}
                                />
                              </VerticalFlex>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>업종</P>
                            </FlexChild>
                            <FlexChild>
                              <VerticalFlex alignItems="flex-start" gap={10}>
                                <InputText
                                  validable={false}
                                  ref={(el) => (inputs.current[11] = el)}
                                  value={data?.businessDetail}
                                />
                              </VerticalFlex>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>업태</P>
                            </FlexChild>
                            <FlexChild>
                              <VerticalFlex alignItems="flex-start" gap={10}>
                                <InputText
                                  validable={false}
                                  ref={(el) => (inputs.current[12] = el)}
                                  value={data?.businessType}
                                />
                              </VerticalFlex>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>사업자 등록증</P>
                            </FlexChild>
                            <FlexChild>
                              <VerticalFlex alignItems="flex-start" gap={10}>
                                <AdminInputImage
                                  ref={(el) => (inputs.current[13] = el)}
                                  name="사업자 등록증"
                                  path="/customer"
                                  labelWidth={0}
                                  cropWidth={600}
                                  cropHeight={600}
                                  value={data && data.businessCertificate}
                                  maxSizeMb={1}
                                />
                              </VerticalFlex>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>소매인 지정서</P>
                            </FlexChild>
                            <FlexChild>
                              <AdminInputImage
                                ref={(el) => (inputs.current[14] = el)}
                                name="소매인 지정서"
                                path="/customer"
                                labelWidth={0}
                                cropWidth={600}
                                cropHeight={600}
                                value={data && data.businessRetail}
                                maxSizeMb={1}
                              />
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                      </VerticalFlex>
                    </div>
                  </FlexChild>
                </VerticalFlex>
              </div>
            </FlexChild>
            <HorizontalFlex padding={15} gap={10} justifyContent="center">
              <FlexChild width="max-content">
                <AdminCustomButton
                  style={buttonStyle.white_border}
                  text={"취소"}
                  onClick={onCloseClick}
                />
              </FlexChild>
              <FlexChild width="max-content">
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {isSpin && (
                    <CSpinner style={{ position: "absolute", zIndex: 100 }} />
                  )}
                  <AdminCustomButton
                    style={buttonStyle.white_border}
                    text={"저장"}
                    onClick={onSaveClick}
                  />
                </div>
              </FlexChild>
            </HorizontalFlex>
          </VerticalFlex>
        </Container>
      </div>
    </ModalBase>
  );
});

export default CustomerEditModal;
